function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

class SFScroll
{
    constructor({ debug }) {
        this.debug = typeof debug === 'undefined' ? false : debug
        this.debugLines = {}

        this.items = []

        window.addEventListener('scroll', () => this.check())
        window.addEventListener('resize', () => this.check())

        this.init()
    }

    init() {
        document.querySelectorAll('[data-sf-scroll]').forEach(elem => this.initElement(elem))
    }

    initElement(elem) {
        const str = elem.getAttribute('data-sf-scroll')
        if (!str) {
            throw new Error('no or invalid data-sf-scroll attribute')
        }
        const data = JSON.parse(str)
        if (!data || typeof data.from === 'undefined' || typeof data.to === 'undefined') {
            throw new Error('invalid data-sf-scroll')
        }

        let targetElem = null
        if (elem.hasAttribute('data-target')) {
            const targetSelector = elem.getAttribute('data-target')
            targetElem = document.querySelector(targetSelector)
            if (typeof targetElem === 'undefined') {
                throw new Error('unknown target element: ' + targetSelector)
            }
        }

        const position = elem.hasAttribute('data-position') ? parseFloat(elem.getAttribute('data-position')) : 50

        if (targetElem && !targetElem) {
            targetElem.id = uuidv4()
        }

        const uuid = targetElem ? targetElem.id : uuidv4()

        this.items.push({ uuid, elem, data, targetElem, position })
        this.check()
    }

    check() {
        this.items.forEach(item => {
            const box = item.targetElem
                ? item.targetElem.getBoundingClientRect()
                : item.elem.getBoundingClientRect()

            const startPosition = window.innerHeight
            const endPosition = startPosition - (window.innerHeight / item.position)
            const areaHeight = startPosition - endPosition

            let percent
            if (box.top >= startPosition) {
                this.setStyle(item.elem, item.data.from)
                percent = 0
            } else if (box.top <= endPosition) {
                this.setStyle(item.elem, item.data.to)
                percent = 100
            } else {
                percent = 100 + (((endPosition - box.top) * 100) / areaHeight)
                const factor = percent / 100

                const attrs = {}
                for (const key in item.data.from) {
                    const diff = item.data.to[key] - item.data.from[key]
                    const value = item.data.from[key] + (diff * factor)
                    attrs[key] = Math.round(value * 10) / 10
                }
                this.setStyle(item.elem, attrs)
            }

            if (this.debug) {
                this.paintDebugPosition(item.uuid, box.top, percent)
                this.paintDebugArea(item.uuid, endPosition, areaHeight)
            }
        })
    }

    setStyle(elem, attrs) {
        for (let key in attrs) {
            let value = attrs[key]
            if (['x', 'y'].includes(key)) {
                value = `translate${key.toUpperCase()}(${value}px)`
                key = 'transform'
            }
            elem.style[key] = value
        }
    }

    paintDebugArea(uuid, top, height) {
        if (!Object.keys(this.debugLines).includes(uuid)) {
            this.debugLines[uuid] = {
                right: Object.keys(this.debugLines).length * 15
            }
        }

        const right = this.debugLines[uuid].right

        const id = `sf-scroll-debug-area-${uuid}`

        let elem = document.getElementById(id)

        if (!elem) {
            const style = {
                position: 'fixed',
                right: `${right}px`,
                width: '10px',
                background: '#f00',
                opacity: .3,
                zIndex: 9998,
                pointerEvents: 'none',
            }

            elem = document.createElement('div')
            elem.id = id
            for (const key in style) {
                elem.style[key] = style[key]
            }
            document.body.appendChild(elem)
        }
        elem.style.top = `${top}px`
        elem.style.height = `${height}px`
    }

    paintDebugPosition(uuid, position, percent) {
        if (!Object.keys(this.debugLines).includes(uuid)) {
            this.debugLines[uuid] = {
                right: Object.keys(this.debugLines).length * 15
            }
        }

        const right = this.debugLines[uuid].right

        const id = `sf-scroll-debug-item-${uuid}`

        let elem = document.getElementById(id)

        if (!elem) {
            const style = {
                position: 'fixed',
                right: `${right}px`,
                borderRight: '10px solid #f00',
                paddingRight: '10px',
                color: '#f00',
                zIndex: 9999,
                pointerEvents: 'none',
            }

            elem = document.createElement('div')
            elem.id = id
            for (const key in style) {
                elem.style[key] = style[key]
            }
            document.body.appendChild(elem)
        }
        elem.innerText = `${uuid} (${parseInt(percent)}%}`
        elem.style.top = `${position}px`
    }
}

export default SFScroll
